module.exports = __webpack_public_path__ + "img/banner-chung-cu-pcc1-thanh-xuan.2feaff1f.jpg";